var map = {
	"./da.json": "./src/js/components/PlanQuiz/assets/da.json",
	"./de.json": "./src/js/components/PlanQuiz/assets/de.json",
	"./en.json": "./src/js/components/PlanQuiz/assets/en.json",
	"./es.json": "./src/js/components/PlanQuiz/assets/es.json",
	"./fr.json": "./src/js/components/PlanQuiz/assets/fr.json",
	"./it.json": "./src/js/components/PlanQuiz/assets/it.json",
	"./nl.json": "./src/js/components/PlanQuiz/assets/nl.json",
	"./no.json": "./src/js/components/PlanQuiz/assets/no.json",
	"./pt.json": "./src/js/components/PlanQuiz/assets/pt.json",
	"./ru.json": "./src/js/components/PlanQuiz/assets/ru.json",
	"./sv.json": "./src/js/components/PlanQuiz/assets/sv.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/js/components/PlanQuiz/assets sync recursive ^\\.\\/.*\\.json$";